import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getHTML } from '../../../services/commonFunction';
import { ArrowRight, Eye, Zap, ExternalLink } from 'lucide-react';

const ProductCard = ({ data }) => {
  const contentData = useSelector(state => state.Data.contentData);
  const langPrefix = useSelector(state => state.Data.langPrefix);
  const [isHovered, setIsHovered] = useState(false);
  console.log("fff", data)
  return (
    <div 
      className="group cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-400 h-full border border-gray-200">
        {/* Image with Soft Frame */}
        <div className="relative h-56 overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
          <div className="p-4">
            <div className="relative h-44 rounded-lg overflow-hidden">
              <img 
                src={data?.image_full_url} 
                alt={data?.translate?.title}
                className={`w-full h-full object-cover transition-transform duration-600 ${
                  isHovered ? 'scale-110 rotate-1' : 'scale-100'
                }`}
              />
              
              {/* Semi-transparent Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent transition-opacity duration-400 ${
                isHovered ? 'opacity-100' : 'opacity-0'
              }`}></div>
            </div>
          </div>
          
          {/* Floating Action */}
          <div className={`absolute bottom-4 right-4 transition-all duration-400 ${
            isHovered ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
          }`}>
            <Link
              to={`/${langPrefix}product/${data?.path}`}
              className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all"
            >
              <ArrowRight className="w-5 h-5 text-white" />
            </Link>
          </div>
        </div>
        
        {/* Content */}
        <div className="p-5">
          <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
            {data?.translate?.title}
          </h3>
          
          <p className="text-gray-600 text-sm mb-4 line-clamp-2">
            {getHTML(data?.translate?.description)
              ?.replaceAll("&nbsp;", " ")
              ?.replaceAll("&nbsp", " ")
              ?.substring(0, 80) || 
              ''}
          </p>
          
          {/* Minimal Button */}
          <div className="flex items-center justify-between pt-3 border-t border-gray-100">
            <span className="text-xs text-gray-500">{data?.category?.translate?.title}</span>
            <Link
              to={`/${langPrefix}product/${data?.path}`}
              className="text-blue-600 hover:text-blue-700 text-sm font-medium flex items-center space-x-1"
            >
              <span>{contentData?.more_view}</span>
              <ArrowRight className="w-3 h-3" />
            </Link>
          </div>
        </div>
        
        {/* Side Accent Line */}
        <div className={`h-1 bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-400 ${
          isHovered ? 'w-full' : 'w-16'
        }`}></div>
      </div>
    </div>
  );
};

export default ProductCard;